export function formatDate(date: string | Date, format = 'default', locale = 'en') {
  if (!date) return '';

  const hasTimezone = typeof date === 'string' && /(?:Z|[+-]\d{2}:\d{2})$/i.test(date);
  const dateString = typeof date === 'string' && !hasTimezone ? date + 'Z' : date;
  const dateObj = new Date(dateString);

  if (isNaN(dateObj.getTime())) {
    return 'Invalid Date';
  }

  const formats = {
    default: { day: 'numeric', month: 'short', year: 'numeric' },
    short: { day: '2-digit', month: '2-digit', year: 'numeric' },
    long: { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' },
    medium: { day: 'numeric', month: 'long', year: 'numeric' },
    time: { hour: '2-digit', minute: '2-digit' },
    datetime: { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' },
    iso: null
  };

  if (format === 'iso') {
    return dateObj.toISOString().split('T')[0];
  }

  let localeStr = 'en-US';

  if (locale === 'cs') {
    localeStr = 'cs-CZ';
  } else if (locale === 'fi') {
    localeStr = 'fi-FI';
  }

  const options = {
    ...formats[format] || formats.default,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
  };

  return new Intl.DateTimeFormat(localeStr, options).format(dateObj);
}

export function addBusinessDays(date: Date, days: number): Date {
  const result = new Date(date);
  let addedDays = 0;
  
  while (addedDays < days) {
    result.setDate(result.getDate() + 1);
    
    const dayOfWeek = result.getDay();
    
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      addedDays++;
    }
  }
  
  return result;
}